import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField';
import PhoneField from '../../custom/PhoneField';
import MailField from '../../custom/MailField';
import Adresse from './Adresse';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircle from '@material-ui/icons/RemoveCircle';

import './Personne.css';
import '../EditionPage.css';

class Personne extends Component {

    constructor(props) {
        super(props);
        this.state = {
            civilite: this.props.personne.civilite,
            nom: this.props.personne.nom,
            prenom: this.props.personne.prenom,
            obs: this.props.personne.obs,
        }
    }

    handleChangeCivilite = event => {
        this.setState({civilite: event.target.value}); 
        this.props.personne.civilite=event.target.value;
    } 

    handleChange = (champ)  => event => {
        this.props.personne[champ]=event.target.value;
        this.setState({
            [champ]: event.target.value,
        });
    }

    render(){
        var styleBoutonRemovePers = {}
        if(this.props.id < 1) {
            styleBoutonRemovePers={'display': 'none'}
        }
        return (
            <div className='personne'>                
                <IconButton
                    aria-haspopup="true"
                    onClick={this.props.removePers}
                    className="infosClientRemovePers"
                    color="secondary"
                    title="Supprimer la personne"
                    style={styleBoutonRemovePers}>
                    <RemoveCircle />
                </IconButton>
                <FormControl component="fieldset">
                <FormLabel component="legend">Civilit&eacute;</FormLabel>
                <RadioGroup
                    aria-label="Civilite"
                    name="civilite"            
                    value={this.state.civilite}
                    onChange={this.handleChangeCivilite}
                    className="inlineRadio">
                    <FormControlLabel value="m" control={<Radio color="primary" />} label="M." />
                    <FormControlLabel value="f" control={<Radio color="primary" />} label="Mme" />
                </RadioGroup>
                </FormControl>
                <div className="inlineInputs">
                    <TextField name='nom' label='Nom' className="nom" value={this.state.nom} onChange={this.handleChange("nom")} />
                    <TextField name='prenom' label='Pr&eacute;nom' className="prenom" value={this.state.prenom} onChange={this.handleChange("prenom")} />
                </div>
                <div className="inlineInputs">
                    <PhoneField id='telephone1' label='T&eacute;l&eacute;phone 1' className="telephone" value={this.props.personne.telephone1} onChange={this.handleChange("telephone1")} />
                    <PhoneField id='telephone2' label='T&eacute;l&eacute;phone 2' className="telephone" value={this.props.personne.telephone2} onChange={this.handleChange("telephone2")} />
                </div>
                <div className="fullWith">
                    <MailField id='mail' label='Adresse mail' value={this.props.personne.mail} onChange={this.handleChange("mail")} />
                </div>
                <TextField name='obs' label='Observations' multiline={true} fullWidth={true} className="obs" value={this.state.obs} onChange={this.handleChange("obs")} />
                <Adresse adresse={this.props.personne.adresse} />
            </div>);
    }
}

Personne.propTypes= {
    personne: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    removePers: PropTypes.func.isRequired,
}


export default Personne


// WEBPACK FOOTER //
// ./src/components/content/client/Personne.js